import Layout from "../../components/layout";
import { GetStaticProps } from "next";
import Link from "next/link";
import React from "react";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import '../../styles/scss/_events-page.module.scss';

export default function ObservabilityWorkshopBengaluru({ props }) {
    const { t } = useTranslation('common');
    return (
        <>
            <Layout isHomePage={false} pageTitle={"Observability Workshop in Bengaluru 2026"}
                ogImage={"/images/events/observability-workshop-bengaluru-2026.webp"}
                uri={"/events/observability-workshop-bengaluru-2026/"}
                metaTitle={"Observability Workshop Bengaluru 2026 | Middleware"}
                metaDesc={"Join Middleware’s exclusive Observability Workshop in Bengaluru on Feb 27, 2026. Hands-on APM, Infrastructure, RUM & cost optimization. Limited seat. Apply now."}
                metaRobotsNoindex={"index"}
                metaRobotsNofollow={"follow"}>

                <div className={'global-wrapper'} >
                    <div className={"event-page dine-with-devops"}>
                        <section className={'hero-section'}>
                            <div className={'container'}>
                                <div className={'d-flex'}>
                                    <div className={'left-block'}>
                                        <Link href={"/events/"} className={"back-to-blog"}>Back to Event List</Link>
                                        <div className={'d-flex aws-mw'}>

                                        </div>
                                        <div className={'inner-hero'}>
                                            <h1><span>Observability </span> Workshop in Bengaluru 2026!</h1>
                                            <p><b>Date: </b>February 27th 2026</p>
                                            <p><b>Venue: </b> Royal Orchid Central, Bengaluru</p>
                                        </div>
                                    </div>
                                    <div className={'right-block closed'}>
                                        <img
                                            src={'/images/events/observability-workshop-bengaluru-2026.webp'} alt={'Observability Workshop in Bengaluru 2026'} width={"100%"} height={"100%"} />
                                    </div>
                                </div>

                            </div>
                        </section>
                        <section className={'content-section'}>
                            <div className={'container'}>
                                <div className={'left-block sm-width'}>
                                    <h4>Complete Your Observability Evaluation in One Day</h4>
                                    <p>If you're evaluating alternatives to Datadog or New Relic, this invite-only workshop is designed to help your team make a confident, fast decision.</p>
                                    <p>Join us for a full-day, hands-on observability workshop in Bengaluru built specifically for engineering, DevOps, and platform teams.
                                    </p>
                                    <h4>Meet Our Team</h4>
                                    <img src={"/images/events/team-observability-workshop-bengaluru-2026.webp"} alt={"Middleware Team"}
                                        width={100} height={100} />

                                    <ul>
                                        <li><Link href={"https://www.linkedin.com/in/sawaramsuthar/"}
                                            target={"_blank"}>Sam Suthar</Link>, Founding Director, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/bhogayatakb/"} target={"_blank"}>Keval
                                            Bhogayata </Link>, Senior Staff Engineer, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/archish-thakkar/"}
                                            target={"_blank"}>Archish Thakkar </Link>, Principal Engineer, Middleware</li>
                                        <li><Link href={"https://www.linkedin.com/in/naman-jain-3a3892284/"}
                                            target={"_blank"}>Naman Jain</Link>, Senior Software Engineer, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/malay-tanna/"}
                                            target={"_blank"}>Malay Tanna</Link>, Growth, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/parjuns/"}
                                            target={"_blank"}>Arjun Prajapati</Link>, Senior Software Engineer, Middleware
                                        </li>
                                        
                                    </ul>

                                    <h4>What’s Middleware All About?</h4>
                                    <p>Middleware is a full-stack cloud observability platform that empowers teams to
                                        optimize cloud operations, reduce downtime, and boost productivity with 100%
                                        ingestion control.
                                    </p>

                                    <h4>What does that mean for your business?</h4>
                                    <p>Upto 10X reduction in observability costs</p>
                                    <p>Upto 75% improvement in operational efficiency</p>
                                    <p>Upto 20% faster time to resolution (MTTR)</p>
                                    <p>Upto 25% improved developer productivity</p>

                                    <h4>Middleware’s Observability Suite Includes: </h4>

                                    <ul>
                                        <li><b>Infrastructure Monitoring:</b> Monitor and optimize infrastructure in
                                            real-time for peak efficiency.
                                        </li>
                                        <li><b>Log Monitoring:</b> Unify log data across your tech stack to quickly
                                            identify and fix issues.
                                        </li>
                                        <li><b>APM:</b> Track app performance, identify bottlenecks and fix issues in
                                            real time.
                                        </li>
                                        <li><b>LLM Observability:</b> Monitor, troubleshoot, and optimize LLM
                                            applications in real time.
                                        </li>
                                        <li><b>AI-Powered Dashboards:</b> Leverage intelligent dashboards with automated insights, anomaly detection, and real-time performance analytics.
                                        </li>
                                        <li><b>Database Monitoring:</b> Visualize and track database metrics in real
                                            time for optimal performance.
                                        </li>
                                        <li><b>Synthetic Monitoring:</b> Simulate your app to spot and fix issues before
                                            they affect customers.
                                        </li>
                                        <li><b>Serverless Monitoring:</b> Get full visibility and control over
                                            serverless apps for optimal performance.
                                        </li>
                                        <li><b>Container Monitoring:</b> Get real-time visibility into containerized
                                            apps with data and analytics.
                                        </li>
                                        <li><b>Real User Monitoring:</b> Analyze user journeys on the web and mobile to
                                            optimize performance and experience.
                                        </li>
                                    </ul>

                                    <h4>Get Hands-on with Middleware:</h4>
                                    <p>If you are wondering how Middleware can help you, register here for a <Link
                                        href={"/demo-request/"}>demo</Link> to see Middleware in action!</p>

                                    <h4>Swag Alert!</h4>
                                    <img src={"/images/events/middleware-swag.jpg"} alt={"Middleware Swag"} width={100} height={100} />
                                    <p>Connect with the Middleware team to grab exclusive Middleware swag!</p>

                                    <h4>Missed us at Observability Workshop?</h4>

                                    <p>No biggie! Schedule a <Link href={"https://middleware.cal.com/sam/middleware?user=sam"} target={"_blank"}>meeting</Link> to boost your cloud
                                        observability, and follow our <Link
                                            href={"https://middleware.io/blog/"}>blog </Link> for product updates and
                                        expert insights. </p>
                                </div>


                            </div>
                        </section>
                    </div>
                </div>

            </Layout>
        </>
    )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
    const translations = await serverSideTranslations(
        ctx?.locale ?? "en",
        ["common", "header", "footer"],
        nextI18NextConfig,
    );
    return {


        props: {
            ...translations,
            pageTitle: "Observability Workshop in Bengaluru 2026",
            description: "Join Middleware’s exclusive Observability Workshop in Bengaluru on Feb 27, 2026. Hands-on APM, Infrastructure, RUM & cost optimization. Limited seat. Apply now.",
            ogImage: "/images/events/observability-workshop-bengaluru-2026.webp",
            uri: "/events/observability-workshop-bengaluru-2026/",
            metaTitle: "Observability Workshop Bengaluru 2026 | Middleware",
            metaDesc: "Join Middleware’s exclusive Observability Workshop in Bengaluru on Feb 27, 2026. Hands-on APM, Infrastructure, RUM & cost optimization. Limited seat. Apply now.",
            metaRobotsNoindex: "index",
            metaRobotsNofollow: "follow",
        },
        // revalidate: 10,
    }
}